import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';
import { CartProvider } from './context/CartContext';
import { WishlistProvider } from './context/WishlistContext';
import { InventoryProvider } from './context/InventoryContext';
import Header from './components/Header';
import Footer from './components/Footer';
import Marquee from './components/Marquee';
import Home from './pages/Home';
import Shop from './pages/Shop';
import ProductDetail from './pages/ProductDetail';
import About from './pages/About';
import FAQ from './pages/FAQ';
import Contact from './pages/Contact';
import Supplies from './pages/Supplies';
import Checkout from './pages/Checkout';
import OrderConfirmation from './pages/OrderConfirmation';
import Wishlist from './pages/Wishlist';
import Admin from './pages/Admin';
import ScrollToTop from './components/ScrollToTop';
import { Toaster } from './components/ui/sonner';

function App() {
  return (
    <div className="App min-h-screen bg-[#0a0a0b] text-neutral-200">
      <HelmetProvider>
        <CartProvider>
          <WishlistProvider>
            <InventoryProvider>
              <BrowserRouter>
                <ScrollToTop />
                <Marquee />
                <Header />
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/shop" element={<Shop />} />
                  <Route path="/products/:slug" element={<ProductDetail />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/faq" element={<FAQ />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/supplies" element={<Supplies />} />
                  <Route path="/checkout" element={<Checkout />} />
                  <Route path="/order/:ref" element={<OrderConfirmation />} />
                  <Route path="/wishlist" element={<Wishlist />} />
                  <Route path="/admin" element={<Admin />} />
                </Routes>
                <Footer />
                <Toaster theme="dark" position="bottom-right" />
              </BrowserRouter>
            </InventoryProvider>
          </WishlistProvider>
        </CartProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
